/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {LonerGameAssets} from "./LonerGameAssets";
import {LonerSound} from "./sound/LonerSound";
import {LonerWinTrigger} from "./gameflow/LonerWinTrigger";
import {LonerNormalBetTrigger} from "./gameflow/LonerNormalBetTrigger";
import {LonerNormalResultTrigger} from "./gameflow/LonerNormalResultTrigger";
import {LonerIdleNormalTrigger} from "./gameflow/LonerIdleNormalTrigger";
import {LonerGameData} from "./server/LonerData";
import {LonerModel} from "./LonerModel";
import {LonerMainAllReelsView} from "./view/mainReels/LonerMainAllReelsView";
import {LonerPoolSymbols} from "./pooling/LonerPoolSymbols";
import {LonerGameMode} from "./server/LonerGameMode";
import {LonerInitialWinView} from "./view/general/LonerInitialWinView";
import {LonerTotalWinView} from "./view/general/LonerTotalWinView";
import {LonerWinWaysView} from "./view/general/LonerWinWaysView";
import {LonerIndividualWinView} from "./view/general/LonerIndividualWinView";
import {LonerBigWinView} from "./view/general/LonerBigWinView";
import {LonerPoolScatterSymbols} from "./pooling/LonerPoolScatterSymbols";
import {LonerWinLineTopView} from "./view/LonerWinLineTopView";
import {LonerSSDIntroView} from "./view/features/shootshootduck/LonerSSDIntroView";
import {LonerShootShootDuckIdleTrigger} from "./gameflow/shootshootduck/LonerShootShootDuckIdleTrigger";
import {LonerShootShootDuckWinTrigger} from "./gameflow/shootshootduck/LonerShootShootDuckWinTrigger";
import {LonerShootShootDuckBetTrigger} from "./gameflow/shootshootduck/LonerShootShootDuckBetTrigger";
import {LonerShootShootDuckResultTrigger} from "./gameflow/shootshootduck/LonerShootShootDuckResultTrigger";
import {LonerSSDOutroView} from "./view/features/shootshootduck/LonerSSDOutroView";
import {LonerForegroundView} from "./view/general/LonerForegroundView";
import {LonerTVMessageView} from "./view/general/LonerTVMessageView";
import {LonerAnticipationView} from "./view/LonerAnticipationView";
import {LonerTickTickBoomView} from "./view/features/ticktickboom/LonerTickTickBoomView";
import {AlarmClockFont} from "./fonts/AlarmClockFont";
import {PixelFont} from "./fonts/PixelFont";
import {LonerKillTheWokeIntroView} from "./view/features/killthewoke/LonerKillTheWokeIntroView";
import {LonerTickTickBoomIdleTrigger} from "./gameflow/ticktickboom/LonerTickTickBoomIdleTrigger";
import {LonerTickTickBoomResultTrigger} from "./gameflow/ticktickboom/LonerTickTickBoomResultTrigger";
import {LonerTickTickBoomWinTrigger} from "./gameflow/ticktickboom/LonerTickTickBoomWinTrigger";
import {LonerTickTickBoomBetTrigger} from "./gameflow/ticktickboom/LonerTickTickBoomBetTrigger";
import {LonerTickTickBoomOutroView} from "./view/features/ticktickboom/LonerTickTickBoomOutroView";
import {LonerTickTickBoomIntroView} from "./view/features/ticktickboom/LonerTickTickBoomIntroView";
import {LonerPinTheWinWinTrigger} from "./gameflow/pinthewin/LonerPinTheWinWinTrigger";
import {LonerLogoView} from "./view/LonerLogoView";
import {LonerPinTheWinOutroView} from "./view/features/pinthewin/LonerPinTheWinOutroView";
import {LonerKillTheWokeOutroView} from "./view/features/killthewoke/LonerKillTheWokeOutroView";
import {LonerKillTheWokeMainView} from "./view/features/killthewoke/LonerKillTheWokeMainView";
import {LonerKillTheWokeHiddenMainView} from "./view/features/killthewoke/LonerKillTheWokeHiddenMainView";
import {LonerSymOverlayAnimationsView} from "./view/mainReels/LonerSymOverlayAnimationsView";
import {ResourceCreator} from "./resourcecreator/ResourceCreator";
import {LonerPoolDucks} from "./pooling/LonerPoolDucks";
import {LonerSSDMainView} from "./view/features/shootshootduck/LonerSSDMainView";
import {
    LonerShootShootDuckResponsePresentation
} from "./presentationrunners/features/shootshootduck/LonerShootShootDuckResponsePresentation";
import {
    LonerShootShootDuckOutroPresentation
} from "./presentationrunners/features/shootshootduck/LonerShootShootDuckOutroPresentation";
import {LonerSymbolTopView} from "./view/LonerSymbolTopView";
import {LonerPoolInfectedSymbolSpines} from "./pooling/LonerPoolInfectedSymbolSpines";
import {LonerBigWinPresentation} from "./presentationrunners/general/LonerBigWinPresentation";
import {LonerPoolBigWildSymbols} from "./pooling/LonerPoolBigWildSymbols";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {LonerPinTheWinIntroView} from "./view/features/pinthewin/LonerPinTheWinIntroView";
import {LonerPinTheWinIdleTrigger} from "./gameflow/pinthewin/LonerPinTheWinIdleTrigger";
import {LonerPinTheWinMainView} from "./view/features/pinthewin/LonerPinTheWinMainView";
import {LonerPinTheWinResultTrigger} from "./gameflow/pinthewin/LonerPinTheWinResultTrigger";
import {
    BetFeature,
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {LonerMainGameMaxWinView} from "./view/general/LonerMainGameMaxWinView";
import {LonerSSDMaxWinView} from "./view/features/shootshootduck/LonerSSDMaxWinView";
import {LonerPinTheWinMaxWinView} from "./view/features/pinthewin/LonerPinTheWinMaxWinView";
import {LonerPinTheWinVHSView} from "./view/features/pinthewin/LonerPinTheWinVHSView";
import {gsap, Linear} from "gsap";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {LonerXBetReelView} from "./view/general/LonerXBetReelView";
import {LonerStatics} from "./LonerStatics";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class Loner extends SlotGame {
    public static isActionSpinsActive:boolean = false;
    public static isGodModeRound:boolean = false;

    public static model:LonerModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:LonerSound;
    public static foregroundView:LonerForegroundView;
    public static gameFlowController:GameFlowController;
    public static allReelView:LonerMainAllReelsView;
    public static initialWinView:LonerInitialWinView;
    public static totalWinView:LonerTotalWinView;
    public static winWaysView:LonerWinWaysView;
    public static individualWin:LonerIndividualWinView;
    public static bigWinView:LonerBigWinView;
    public static winLineTopView:LonerWinLineTopView;
    public static symbolTopView:LonerSymbolTopView;
    public static ssdIntroView:LonerSSDIntroView;
    public static ssdOutroView:LonerSSDOutroView;
    public static tvMessageView:LonerTVMessageView;
    public static mainGameMaxWinView:LonerMainGameMaxWinView;
    public static ssdMaxWinView:LonerSSDMaxWinView;
    public static pinTheWinMaxWinView:LonerPinTheWinMaxWinView;
    public static anticipationView:LonerAnticipationView;
    public static tickTickBoomView:LonerTickTickBoomView;
    public static tickTickBoomIntroView:LonerTickTickBoomIntroView;
    public static tickTickBoomOutroView:LonerTickTickBoomOutroView;
    public static killTheWokeIntroView:LonerKillTheWokeIntroView;
    public static killTheWokeOutroView:LonerKillTheWokeOutroView;
    public static killTheWokeMainView:LonerKillTheWokeMainView;
    public static killTheWokeHiddenView:LonerKillTheWokeHiddenMainView;

    public static pinTheWinIntroView:LonerPinTheWinIntroView;
    public static pinTheWinVHSView:LonerPinTheWinVHSView;
    public static pinTheWinMainView:LonerPinTheWinMainView;
    public static pinTheWinOutroView:LonerPinTheWinOutroView;

    public static logoView:LonerLogoView;
    public static symOverlayAnimationsView:LonerSymOverlayAnimationsView;
    public static ssdMainView:LonerSSDMainView;

    public static idleNormal:LonerIdleNormalTrigger;
    public static shootShootDuckResponsePresentation:LonerShootShootDuckResponsePresentation;
    public static ssdOutroPresentation:LonerShootShootDuckOutroPresentation;
    public static bigWinPresentation:LonerBigWinPresentation;

    public static symbolsPool:LonerPoolSymbols;
    public static scatterPool:LonerPoolScatterSymbols;
    public static duckSymbolPool:LonerPoolDucks;
    public static infectedSymbolSpinePool:LonerPoolInfectedSymbolSpines;
    public static wildSymbolPool:LonerPoolBigWildSymbols;
    public static xBetView:LonerXBetReelView;
    private skinner:Skinner;

    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    public static isWinBelowPlayedBetValue():boolean {
        if(!Loner.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        let playedBetValue:number = Loner.model.gameData?.playedBetValue || parseFloat(Loner.apiPlugin.freeBets.hasFreeBets() ? Loner.apiPlugin.freeBets.getBet() : Loner.apiPlugin.betLevel.getLevel());
        //If xbet is on, played bet value should be the xbet cost
        if(Loner.apiPlugin.freeBets.hasFreeBets() == false && Loner.apiPlugin.betHandler.betBoost) {
            playedBetValue = Loner.apiPlugin.betHandler.betBoost?.calculatedPrice;
        }

        return (Loner.model.gameData?.totalSpinWinnings / playedBetValue) <= 1;
    }

    public static isWinBelowStake():boolean {
        return Loner.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.model.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice():number {
        let cost:string = Loner.apiPlugin.betLevel.getLevel();
        const activeBetFeature:BetFeature | undefined = Loner.apiPlugin.betFeatureController.getActiveBetFeature();
        if(activeBetFeature) {
            cost = Loner.apiPlugin.currency.formatValue(activeBetFeature.getTotalCost());
        }
        //Seems to be a bug where there is no active bet on init
        if(Loner.model.featureName.length > 0) {
            for(let index:number = 0; index < Loner.model.initData.featureBuyTimesBetValue.length; index++) {
                if(Loner.model.initData.featureBuyTimesBetValue[index].name == Loner.model.featureName) {
                    let numberCost:number = parseFloat(cost)
                    numberCost *= Loner.model.initData.featureBuyTimesBetValue[index].price;
                    cost = numberCost.toString();
                    break;
                }
            }
            Loner.model.featureName = "";
        }
        return parseFloat(cost);
    }

    public static shake(dur:number, wiggles:number = 40, moveVal:number = 3):gsap.core.Timeline {
        let moveXVal:number = moveVal,
            moveYVal:number = moveVal;
        const stageOriginalPos:PIXI.Point = new PIXI.Point(LonerStatics.stagePos.x, LonerStatics.stagePos.y);
        let wiggleTl:gsap.core.Timeline = gsap.timeline(),
            x:string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y:string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;
        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles : wiggles,
            amplitudeEase : Linear.easeNone,
            timingEase : Linear.easeNone
        });
        wiggleTl.to(NolimitApplication.pixiApp.stage, {
            duration : dur,
            x : x,
            ease : shakeWiggle
        }, 0);
        wiggleTl.to(NolimitApplication.pixiApp.stage, {
            duration : dur,
            y : y,
            ease : shakeWiggle
        }, 0);
        wiggleTl.to(NolimitApplication.pixiApp.stage, {
            x : stageOriginalPos.x,
            y : stageOriginalPos.y,
            duration : 0.01
        });

        return wiggleTl;
    }

    getNolimitBonusDisplayConfiguration():BonusFeatureDisplayConfigurationList {
        return {
            TICK_TICK_BOOM : {
                displayOrder : 0
            },
            PIN_THE_WIN : {
                displayOrder : 1
            },
            SHOOT_SHOOT_DUCK : {
                displayOrder : 2
            },
            "GOD_MODE" : {
                displayOrder : 3,
                replacePopUpContent : (content:BonusBuyPopUpContent) => {
                    const godModeStillImage:PIXI.Sprite = content.featureImage;
                    const godModeSpine:PIXI.spine.Spine = new PIXI.spine.Spine(Loner.assetLoader.getSpineAsset(LonerGameAssets.GOD_MODE_POPUP_SPINE))
                    godModeSpine.state.setAnimation(0, "Loop", true);
                    godModeSpine.position.copyFrom(godModeStillImage);
                    godModeSpine.position.y += 80;

                    content.featureImage = <PIXI.Sprite>(<any>godModeSpine);
                    content.removeChild(godModeStillImage);
                    content.addChild(godModeSpine);

                    content.textLabel.position.y = content.featureImage.position.y + (content.featureImage.height / 2) + 15;
                    content.textLabel.text += "\n\n" + Loner.apiPlugin.translations.translate("Warning: 1 Spin. No Win or Max Win!");

                    if(content.height > 450) {
                        let contentStyleClone:PIXI.TextStyle = content.textLabel.getStyleClone();
                        contentStyleClone.fontSize = (<number>contentStyleClone.fontSize) * (450 / content.height);
                        content.textLabel.setStyle(contentStyleClone);
                    }

                    return content;
                }
            },
            LUCKY_DRAW : {
                displayOrder : 4
            },
            LUCKY_DRAW_2 : {
                displayOrder : 5
            },
        }
    }

    getNoWinGameData():any {
        return {
            "reels" : [
                [
                    "L3",
                    "M1",
                    "L1",
                    "L2",
                    "L2"
                ],
                [
                    "L3",
                    "M2",
                    "M2",
                    "M2",
                    "L2"
                ],
                [
                    "L3",
                    "M3",
                    "L4",
                    "L4",
                    "L2"
                ],
                [
                    "L3",
                    "L1",
                    "M4",
                    "M4",
                    "L2"
                ],
                [
                    "L3",
                    "M1",
                    "M1",
                    "M1",
                    "L2"
                ]
            ],
            "evaluatedArea" : [
                [
                    "M1",
                    "L1",
                    "L2"
                ],
                [
                    "M2",
                    "M2",
                    "M2"
                ],
                [
                    "M3",
                    "L4",
                    "L4"
                ],
                [
                    "L1",
                    "M4",
                    "M4"
                ],
                [
                    "M1",
                    "M1",
                    "M1"
                ]
            ],
            "betWayWins" : [],
            "totalSpinWinnings" : 0,
            "accumulatedRoundWin" : 0,
            "playedBetValue" : 1,
            "mode" : "NORMAL",
            "nextMode" : "NORMAL",
            "numberOfFreespinsPlayed" : 0,
            "freespinsLeft" : 0,
            "wasFeatureBuy" : false,
            "brokeTheBank" : false,
            "freespinTriggeredThisSpin" : false,
            "boostedBet" : false,
            "winMultiplier" : 1,
            "serverChecks" : {
                "overrideReels" : [
                    [
                        "M1",
                        "L1",
                        "L2",
                        null,
                        null
                    ],
                    [
                        "M2",
                        "M2",
                        "M2",
                        null,
                        null
                    ],
                    [
                        "M3",
                        "L4",
                        "L4",
                        null,
                        null
                    ],
                    [
                        "L1",
                        "M4",
                        "M4",
                        null,
                        null
                    ],
                    [
                        "M1",
                        "M1",
                        "M1",
                        null,
                        null
                    ]
                ]
            },
            "symbolSizes" : [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "addedFreespinsThisSpin" : 0,
            "featureString" : 0
        }
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            Loner.model = new LonerModel(SlotGame.apiPlugin, true);
            Loner.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Loner.model);
            Loner.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            Loner.model.events?.on(GameModelEvent.INIT, (data:LonerGameData) => {
                //console.log(data);
            });
            Loner.model.events?.on(GameModelEvent.GAME, (data:LonerGameData) => {
                //console.log(data);
            });

            //Basic
            const winPres:LonerWinTrigger = new LonerWinTrigger();
            Loner.idleNormal = new LonerIdleNormalTrigger();
            const reelStart:LonerNormalBetTrigger = new LonerNormalBetTrigger();
            const normalResult:LonerNormalResultTrigger = new LonerNormalResultTrigger();

            //Tick tick boom
            const tickTickBoomIdle:LonerTickTickBoomIdleTrigger = new LonerTickTickBoomIdleTrigger();
            const tickTickBoomWin:LonerTickTickBoomWinTrigger = new LonerTickTickBoomWinTrigger();
            const tickTickBoomBet:LonerTickTickBoomBetTrigger = new LonerTickTickBoomBetTrigger();
            const tickTickBoomResult:LonerTickTickBoomResultTrigger = new LonerTickTickBoomResultTrigger();

            //Work sleep repeat
            const pinTheWinIdle:LonerPinTheWinIdleTrigger = new LonerPinTheWinIdleTrigger();
            const pinTheWinWinTrigger:LonerPinTheWinWinTrigger = new LonerPinTheWinWinTrigger();
            const pinTheWinBet:LonerShootShootDuckBetTrigger = new LonerShootShootDuckBetTrigger();
            const pinTheWinResult:LonerPinTheWinResultTrigger = new LonerPinTheWinResultTrigger();

            //FreeSpin
            const freeSpinIdle:LonerShootShootDuckIdleTrigger = new LonerShootShootDuckIdleTrigger();
            const freeSpinWin:LonerShootShootDuckWinTrigger = new LonerShootShootDuckWinTrigger();
            const freeSpinBet:LonerShootShootDuckBetTrigger = new LonerShootShootDuckBetTrigger();
            const freeSpinResult:LonerShootShootDuckResultTrigger = new LonerShootShootDuckResultTrigger();

            Loner.gameFlowController.addGameModeFlowStatePresentationMap(LonerGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, Loner.idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Loner.gameFlowController.addGameModeFlowStatePresentationMap(LonerGameMode.FEATURE_TICK_TICK_BOOM, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, tickTickBoomIdle],
                [FlowState.BET, tickTickBoomBet],
                [FlowState.RESULT, tickTickBoomResult],
                [FlowState.WIN, tickTickBoomWin]
            ]));
            Loner.gameFlowController.addGameModeFlowStatePresentationMap(LonerGameMode.FEATURE_PIN_THE_WIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, pinTheWinIdle],
                [FlowState.BET, pinTheWinBet],
                [FlowState.RESULT, pinTheWinResult],
                [FlowState.WIN, pinTheWinWinTrigger]
            ]));
            Loner.gameFlowController.addGameModeFlowStatePresentationMap(LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freeSpinIdle],
                [FlowState.BET, freeSpinBet],
                [FlowState.RESULT, freeSpinResult],
                [FlowState.WIN, freeSpinWin]
            ]));


            //Making sure that skinID is set based  on "replaceWordFree" gcc.
            if (Loner.apiPlugin.gameClientConfiguration.isSet){
                if (Loner.apiPlugin.gameClientConfiguration.sweepGfx){
                    this.skinner.skinId = "sweep";
                }
            }
            else {
                Loner.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED,()=>{
                    if (Loner.apiPlugin.gameClientConfiguration.sweepGfx){
                        this.skinner.skinId = "sweep";
                    }
                })
            }


            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(AlarmClockFont.REGULAR);
            fontLoader.add(PixelFont.REGULAR);

            AssetsConfig.addToAssetsConfig(LonerGameAssets.RESOURCES_GROUPS);
            Loner.assetLoader = new AssetLoader(Loner.apiPlugin, NolimitApplication.resourcePath + "/resources/");




            const allPromises = [fontLoader.load(), Loner.assetLoader.load(ResourcesGroupName.MAIN)];

            if (this.skinner.skinId != undefined) {
                const replaceMap:Map<string, string> = new Map();
                //Bonus
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");

                //Intro
                replaceMap.set("feature6", "Intro_Feature_6.png");

                allPromises.push(this.skinner.loadSkin(replaceMap));
            }


            const promises = Promise.all(allPromises);

            return promises.then((values:any) =>
                ResourceCreator.createResources().then(() => {
                    return value;
                })
            ).then((values:any) => {
                    Loner.symbolsPool = new LonerPoolSymbols();
                    Loner.scatterPool = new LonerPoolScatterSymbols();
                    Loner.duckSymbolPool = new LonerPoolDucks();
                    Loner.infectedSymbolSpinePool = new LonerPoolInfectedSymbolSpines();
                    Loner.wildSymbolPool = new LonerPoolBigWildSymbols();

                    this.createViewsAndComponents();
                    return values;
                }
            );
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            if(Loner.model.isRestore == true) {
                if(Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
                    Loner.ssdMainView.initAnimators();
                    Loner.ssdMainView.show();
                }
                if(Loner.model.data.mode !== LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
                    Loner.keypadPlugin.setWin(Loner.model.initData.accumulatedRoundWin, false, Loner.isWinBelowStake());
                }
            }
            Loner.soundPlayer.playSound(LonerSound.SPLASH_INTRO_LOOP, 1, Number.MAX_VALUE);
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.\
        return super.start().then((value:NolimitPlugin) => {
            Loner.soundPlayer.stopSound(LonerSound.SPLASH_INTRO_LOOP);
            Loner.gameFlowController.start();
            Loner.soundPlayer.switchMusic(Loner.model.data.mode);
            if(Loner.model.isRestore == false) {
                Loner.soundPlayer.playSound(LonerSound.START_GAME);
            } else {
                if(Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
                    Loner.ssdMainView.restore();
                }
                if(Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM) {
                    Loner.tickTickBoomIntroView.restore();
                }
            }
            Loner.foregroundView.playIdlePizzaDrop(3);
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        Loner.soundPlayer = new LonerSound();

        Loner.symbolTopView = new LonerSymbolTopView();

        Loner.symbolsPool.init();
        Loner.scatterPool.init();
        Loner.duckSymbolPool.init();
        Loner.infectedSymbolSpinePool.init();
        Loner.wildSymbolPool.init();

        Loner.winLineTopView = new LonerWinLineTopView();

        //Static views
        Loner.allReelView = new LonerMainAllReelsView();
        Loner.foregroundView = new LonerForegroundView();
        Loner.foregroundView.setMode(LonerGameMode.ENDLESS_IDLE);
        Loner.totalWinView = new LonerTotalWinView();
        Loner.initialWinView = new LonerInitialWinView();
        Loner.winWaysView = new LonerWinWaysView();
        Loner.individualWin = new LonerIndividualWinView();
        Loner.bigWinView = new LonerBigWinView();
        Loner.ssdIntroView = new LonerSSDIntroView();
        Loner.ssdOutroView = new LonerSSDOutroView();
        Loner.tvMessageView = new LonerTVMessageView();
        Loner.mainGameMaxWinView = new LonerMainGameMaxWinView();
        Loner.ssdMaxWinView = new LonerSSDMaxWinView();
        Loner.pinTheWinMaxWinView = new LonerPinTheWinMaxWinView();
        Loner.anticipationView = new LonerAnticipationView();
        Loner.tickTickBoomView = new LonerTickTickBoomView();
        Loner.tickTickBoomIntroView = new LonerTickTickBoomIntroView();
        Loner.tickTickBoomOutroView = new LonerTickTickBoomOutroView();
        //Loner.killTheWokeIntroView = new LonerKillTheWokeIntroView();
        //Loner.killTheWokeOutroView = new LonerKillTheWokeOutroView();
        //Loner.killTheWokeMainView = new LonerKillTheWokeMainView();
        //Loner.killTheWokeHiddenView = new LonerKillTheWokeHiddenMainView();
        Loner.logoView = new LonerLogoView();
        Loner.pinTheWinOutroView = new LonerPinTheWinOutroView();
        Loner.symOverlayAnimationsView = new LonerSymOverlayAnimationsView();
        Loner.ssdMainView = new LonerSSDMainView();
        Loner.pinTheWinIntroView = new LonerPinTheWinIntroView();
        Loner.pinTheWinMainView = new LonerPinTheWinMainView();
        Loner.pinTheWinVHSView = new LonerPinTheWinVHSView();
        Loner.xBetView = new LonerXBetReelView();
        LonerStatics.stagePos = NolimitApplication.pixiApp.stage.position;

        Loner.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:any) => {
            if(data === true) {
                Loner.isActionSpinsActive = true;
                Loner.individualWin.stop();
            } else {
                Loner.isActionSpinsActive = false;
            }
        });

        NolimitApplication.addLayerAt(Loner.ssdIntroView.name, Loner.ssdIntroView, 0);
        NolimitApplication.addLayerAt(Loner.mainGameMaxWinView.name, Loner.mainGameMaxWinView, 0);
        NolimitApplication.addLayerAt(Loner.ssdMaxWinView.name, Loner.ssdMaxWinView, 0);
        NolimitApplication.addLayerAt(Loner.pinTheWinMaxWinView.name, Loner.pinTheWinMaxWinView, 0);
        NolimitApplication.addLayerAt(Loner.ssdOutroView.name, Loner.ssdOutroView, 0);
        NolimitApplication.addLayerAt(Loner.bigWinView.name, Loner.bigWinView, 0);
        NolimitApplication.addLayerAt(Loner.logoView.name, Loner.logoView, 0);
        NolimitApplication.addLayerAt(Loner.tickTickBoomOutroView.name, Loner.tickTickBoomOutroView, 0);
        NolimitApplication.addLayerAt(Loner.tickTickBoomIntroView.name, Loner.tickTickBoomIntroView, 0);
        NolimitApplication.addLayerAt(Loner.winWaysView.name, Loner.winWaysView, 0);
        NolimitApplication.addLayerAt(Loner.pinTheWinVHSView.name, Loner.pinTheWinVHSView, 0);
        NolimitApplication.addLayerAt(Loner.pinTheWinIntroView.name, Loner.pinTheWinIntroView, 0);
        NolimitApplication.addLayerAt(Loner.pinTheWinOutroView.name, Loner.pinTheWinOutroView, 0);
        NolimitApplication.addLayerAt(Loner.foregroundView.name, Loner.foregroundView, 0);
        NolimitApplication.addLayerAt(Loner.xBetView.name, Loner.xBetView, 0);
        NolimitApplication.addLayerAt(Loner.anticipationView.name, Loner.anticipationView, 0);
        NolimitApplication.addLayerAt(Loner.ssdMainView.name, Loner.ssdMainView, 0);
        NolimitApplication.addLayerAt(Loner.totalWinView.name, Loner.totalWinView, 0);
        NolimitApplication.addLayerAt(Loner.individualWin.name, Loner.individualWin, 0);
        NolimitApplication.addLayerAt(Loner.initialWinView.name, Loner.initialWinView, 0);
        NolimitApplication.addLayerAt(Loner.tickTickBoomView.name, Loner.tickTickBoomView, 0);
        NolimitApplication.addLayerAt(Loner.symOverlayAnimationsView.name, Loner.symOverlayAnimationsView, 0);
        NolimitApplication.addLayerAt(Loner.winLineTopView.name, Loner.winLineTopView, 0);
        NolimitApplication.addLayerAt(Loner.symbolTopView.name, Loner.symbolTopView, 0);
        NolimitApplication.addLayerAt(Loner.pinTheWinMainView.name, Loner.pinTheWinMainView, 0);
        NolimitApplication.addLayerAt(Loner.tvMessageView.name, Loner.tvMessageView, 0);
        NolimitApplication.addLayerAt(Loner.allReelView.name, Loner.allReelView, 0);
    }


    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath:"screens/images/"
            };

            if (this.skinner.skinId != undefined){
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString:string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);

            resolve(paytableString);
        });
    }
}

